// @ts-nocheck
import React from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const ShipMethodFormDialogContent = React.lazy(
  () => import('./ShipMethodformDialogContent'),
);

function ShipMethodFormDialog({
  dialogName,
  payload: { shipMethodId = null, action } = {},
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={action === 'edit' ? <T id={'edit_ship_method'} /> : <T id={'new_ship_method'} />}
      isOpen={isOpen}
      canEscapeKeyClose={true}
      autoFocus={true}
      className={'dialog--ship-method-form'}
      style={{ width: '444px', maxWidth: '95vw' }}
    >
      <DialogSuspense>
        <ShipMethodFormDialogContent
          dialogName={dialogName}
          shipMethodId={shipMethodId}
          action={action}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(ShipMethodFormDialog);
